//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button'
import Card from '@/components/Register/components/Card.vue'
import { FormInput, FormInputPassword } from '@/components/Form'

export default {
  name: 'SetPassword',
  middleware: ['user-validate'],
  components: {
    Card,
    Button,
    FormInput,
    FormInputPassword,
  },
  props: {
    phase: {
      type: String,
      default: '0',
    },
    form: {
      type: Object,
      default: () => ({
        identification_number: '',
        names: '',
        lastnames: '',
        email: '',
        phone: '',
        birthdate: null,
        gender: {},
        education_level: {},
        region: '',
        comune: '',
        terms: false,
        password: '',
        confirmation: '',
      }),
    },
    setValue: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    submit() {
      this.$emit('setValue', this.form)
    },
  },
}
